import { cn } from '@bridebook/aura';

export type FieldDescriptionProps = React.ComponentPropsWithoutRef<'div'>;

export const FieldDescription = ({ className, children, ...props }: FieldDescriptionProps) => {
  if (!children) return null;
  return (
    <div className={cn('typo-sm text-space', className)} {...props}>
      {children}
    </div>
  );
};

FieldDescription.displayName = 'FieldDescription';
